import { useRef, useState } from 'react';
import { Camera, FloppyDisk } from '@phosphor-icons/react';
import Avatar from '../../../shared/components/Avatar';
import PageHeader from '../../../shared/components/PageHeader';
import CropModal from './Parts/CropModal';

type AccountPageProps = {
  user: any;
  onSave: (profile: any) => void;
  back: () => void;
  t: any;
};

export default function AccountPage({ user, onSave, back, t }: AccountPageProps) {
  const [form, setForm] = useState(user);
  const [crop, setCrop] = useState<string>();
  const fileInput = useRef<HTMLInputElement | null>(null);

  const loadFile = (files?: FileList | null) => {
    const file = files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => setCrop(String(reader.result));
    reader.readAsDataURL(file);
  };

  return (
    <PageHeader back={back} eyebrow={t.yourProfile} title={t.account} subtitle={t.accountSubtitle}>
      <section className="account-card">
        <button
          className="profile-upload"
          onClick={() => fileInput.current?.click()}
          onDrop={(event: any) => {
            event.preventDefault();
            loadFile(event.dataTransfer.files);
          }}
          onDragOver={(event: any) => event.preventDefault()}
        >
          {form.avatar ? <img src={form.avatar} alt="" /> : <Avatar user={form} size={112} />}
          <span><Camera weight="fill" /></span>
          <input
            ref={fileInput}
            hidden
            type="file"
            accept="image/*"
            onChange={(event: any) => loadFile(event.target.files)}
          />
        </button>
        <p>{t.uploadPhoto}</p>
        <div className="form-grid two">
          <label>
            {t.firstName}
            <input value={form.firstName} onChange={(event: any) => setForm({ ...form, firstName: event.target.value })} />
          </label>
          <label>
            {t.lastName}
            <input value={form.lastName} onChange={(event: any) => setForm({ ...form, lastName: event.target.value })} />
          </label>
        </div>
        <label>
          {t.username}
          <div className="input-prefix">
            <span>@</span>
            <input value={form.username} onChange={(event: any) => setForm({ ...form, username: event.target.value })} />
          </div>
          <small>{t.usernameLimit}</small>
        </label>
        <label>{t.email}<input disabled value={form.email} /></label>
        <button className="primary account-save" onClick={() => onSave(form)}>
          <FloppyDisk />{t.save}
        </button>
      </section>
      {crop && (
        <CropModal
          t={t}
          src={crop}
          onClose={() => setCrop(undefined)}
          onDone={(avatar) => {
            setForm({ ...form, avatar });
            setCrop(undefined);
          }}
        />
      )}
    </PageHeader>
  );
}
